export default __webpack_public_path__ + "src/assets/icn-toast-alert.aab7d996cfa85df49a38ae7e8c3f9129.svg";